var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212221",
    d: "M0 4.6c0-1.265 1.017-2.3 2.26-2.3h15.825c.6 0 1.175.242 1.599.674a2.32 2.32 0 0 1 .662 1.626v16.1a2.32 2.32 0 0 1-.662 1.626 2.24 2.24 0 0 1-1.599.674H2.262a2.24 2.24 0 0 1-1.599-.674A2.32 2.32 0 0 1 0 20.7zm2.26 2.3v13.8h15.825V6.9zM4.522 0h2.261v2.3h-2.26zm9.043 0h2.26v2.3h-2.26zM4.521 10.35h2.261v2.3h-2.26zm0 4.6h2.261v2.3h-2.26zm4.522-4.6h2.26v2.3h-2.26zm0 4.6h2.26v2.3h-2.26zm4.521-4.6h2.26v2.3h-2.26zm0 4.6h2.26v2.3h-2.26z"
  })));
};
export default SvgDate;